import React from 'react'
import { Controller, Control, UseFormHandleSubmit, UseFormReturn } from 'react-hook-form'
import Box from './Box'
import GrooverText from './GrooverText'
import { TextFieldWithLabelForm } from './TextFieldWithLabelForm'
import { ContinueButton } from './StyledComponents'
import { getGrooverText } from '../libs/GrooverTextRepository'

interface SsnFormValues {
  userSsnField: string
}

interface ReceiptSsnInputFormProps {
  control: Control<SsnFormValues>
  handleSubmit: UseFormHandleSubmit<SsnFormValues>
  formState: UseFormReturn<SsnFormValues>['formState']
  isSaving: boolean
  onSave: (ssn: string) => void
}

export const ReceiptSsnInputForm: React.FC<ReceiptSsnInputFormProps> = ({
  control,
  handleSubmit,
  formState,
  isSaving,
  onSave
}) => (
  <Box fullWidth direction="row" align="center" gap="8px">
    <Controller
      control={control}
      name="userSsnField"
      render={({ field, fieldState }) => (
        <TextFieldWithLabelForm
          {...field}
          value={field.value}
          fullWidth
          fieldState={fieldState}
          placeholder={getGrooverText('registrationStep5PaymentInputAddPersonalNumberHelper')}
        />
      )}
    />
    <ContinueButton
      isDisabled={isSaving || !formState.isValid}
      disabled={isSaving || !formState.isValid}
      onClick={handleSubmit((data) => onSave(data.userSsnField))}
    >
      <GrooverText textKey="registrationCtactaContinue" />
    </ContinueButton>
  </Box>
)
